























import {Component, Vue} from 'vue-property-decorator';
import {PostDetail} from '@/models/post';
import {namespace} from 'vuex-class';
import PostInfo from '@/components/PostInfo.vue';
import PostCategory from '@/components/PostCategory.vue';
import RelatedPosts from '@/components/RelatedPosts.vue';
const blog = namespace('blog');
const loader = namespace('loader');

@Component({
  components: {RelatedPosts, PostCategory, PostInfo},
})
export default class Detail extends Vue {
  @blog.State
  private postDetail!: PostDetail;

  @blog.Action
  private fetchPostBySlug!: (slugId: string) => Promise<void>;

  @blog.Action
  private fetchRelatedPosts!: (id: number) => Promise<void>;

  @loader.Mutation
  private setDoNotLoad!: () => void;

  async mounted() {
    if (this.$attrs.slugId) {
      await this.fetchPostBySlug(this.$attrs.slugId);
      if (this.postDetail) {
        this.setDoNotLoad();
        await this.fetchRelatedPosts(this.postDetail.ID);
      }
    }
  }
}
